export const providerNames = new Map();
providerNames.set('constant', 'Wartość stała');
providerNames.set('condition-provider', 'Warunek logiczny');
providerNames.set('count-provider', 'Sztuk formatu');
providerNames.set('price-provider', 'Kwota formatu');
providerNames.set('revert-provider', 'Odwrócenie wartości');
providerNames.set('sum-provider', 'Suma danych wartości');
providerNames.set('all-orderd-image-formats-sum-provider', 'Sztuk zamówień, wszystkie oferty');
providerNames.set('per-item', 'Cena za sztukę');
providerNames.set('multiply-provider', 'Mnożenie wartości');
providerNames.set('per-item-tiers-provider', 'Progi cenowe za sztukę');
